import script from "./PaymentGatewayDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentGatewayDialog.vue?vue&type=script&setup=true&lang=js"

import "./PaymentGatewayDialog.vue?vue&type=style&index=0&id=eb85d164&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb85d164"]])

export default __exports__